import get from "lodash/get";

export function userHasRole(user, role) {
  if (!user) return false;
  const userRole = get(user, "role");
  const userRoles = get(user, "roles", {});
  if (role in userRoles) {
    return true;
  }
  return userRole === role;
}

export function userRoleExists(user) {
  const userRole = get(user, "role", null);
  const userRoles = get(user, "roles", null);
  return Boolean(userRole || userRoles);
}
